import React, { createContext, ReactNode, useContext, useState } from "react";

import { ProjectBudget, ProjectBudgetService } from ".";

interface IProps {
	children?: ReactNode;
}

interface IProjectBudgetContextType {
	budget?: ProjectBudget;
	fetchProjectBudget?: (budgetId: number) => any;
	save?: () => void;
	setBudget?: React.Dispatch<any>;
}

const ProjectBudgetContext = createContext<IProjectBudgetContextType>({});

export const ProjectBudgetProvider = (props: IProps) => {
	const [budget, setBudget] = useState<ProjectBudget>();

	const projectBudgetService = new ProjectBudgetService();

	const fetchProjectBudget = async (budgetId: number) => {
		const fetched = await projectBudgetService.findById(budgetId);
		setBudget(fetched);

		return budget;
	};

	const save = async () => {
		if (budget) {
			const updatedBudget = await projectBudgetService.save(budget);
			setBudget(updatedBudget);
		}
	};

	// pass the value in provider and return
	return (
		<ProjectBudgetContext.Provider
			value={{
				budget,
				fetchProjectBudget,
				save,
				setBudget,
			}}
		>
			{props.children}
		</ProjectBudgetContext.Provider>
	);
};

export const useProjectBudgetContext = () => {
	return useContext(ProjectBudgetContext);
};
